import { FormEvent } from 'react';
import { Input } from './input';
import { UserInfo } from 'AppTypes';
import batteryImg from '../images/multimedia.png'

interface PersonalInfoProps {
	userInfo: UserInfo;
	updateUserInfo: (userInfo: UserInfo) => void;
	showRequired: boolean;
}

export const PersonalInfo = ({
	userInfo,
  data,
  setData,
	updateUserInfo,
	showRequired,
}:any) => {
	const handlePersonalInfo = (
		event: FormEvent<HTMLInputElement>,
		key: keyof UserInfo
	) => {
		const updatedUserInfo = { ...userInfo };
		updatedUserInfo[key] = event.currentTarget.value;
		updateUserInfo(updatedUserInfo);
	};

	return (
		<section className="flex flex-col gap-4 w-full">
			<h2>Battery Composition</h2>
			<p style={{paddingBottom:"30px"}}>Select the exact composition of your battery.</p>





        <form action="" className="space-y-4">




          <div className="grid grid-cols-1 gap-4 text-center sm:grid-cols-3">
          <div>
  <label > Lithium (Li) </label>

  <div className="flex items-center gap-1" style={{textAlignLast:"center"}}>


    <input
      type="number"
      id="Quantity"
      min={0}
       defaultValue={
        data.battery_composition.Li
       }
        onChange={(e) => {
          setData(
            {
              ...data,
              battery_composition: {
                ...data.battery_composition,
                Li: e.target.value,
              },
            }
          );
        }
      }


    />


  </div>

</div>
<div>
  <label  > Fluorine (F) </label>

  <div className="flex items-center gap-1" style={{textAlignLast:"center"}}>


    <input
      type="number"
      id="Quantity"
      min={0}
        defaultValue={
          data.battery_composition.F
        }
          onChange={(e) => {
            setData(
              {
                ...data,
                battery_composition: {
                  ...data.battery_composition,
                  F: e.target.value,
                },
              }
            );
          }
        }

    />


  </div>

</div>    <div>
  <label  > Aluminium (Al) </label>

  <div className="flex items-center gap-1" style={{textAlignLast:"center"}}>


    <input
      type="number"
      id="Quantity"
      min={0}
        defaultValue={
          data.battery_composition.Al
        }
          onChange={(e) => {
            setData(
              {
                ...data,
                battery_composition: {
                  ...data.battery_composition,
                  Al: e.target.value,
                },
              }
            );
          }
        }

    />


  </div>

</div>
          </div>
          <div className="grid grid-cols-1 gap-4 text-center sm:grid-cols-3">
          <div>
  <label > Phosphor (P) </label>

  <div className="flex items-center gap-1" style={{textAlignLast:"center"}}>


    <input
      type="number"
      id="Quantity"
      min={0}

          defaultValue={
            data.battery_composition.P
          }
            onChange={(e) => {
              setData(
                {
                  ...data,
                  battery_composition: {
                    ...data.battery_composition,
                    P: e.target.value,
                  },
                }
              );
            }
          }


    />


  </div>

</div>
<div>
  <label  > Sulfur (S) </label>

  <div className="flex items-center gap-1" style={{textAlignLast:"center"}}>


    <input
      type="number"
      id="Quantity"
      min={0}

            defaultValue={
              data.battery_composition.S
            }
              onChange={(e) => {
                setData(
                  {
                    ...data,
                    battery_composition: {
                      ...data.battery_composition,
                      S: e.target.value,
                    },
                  }
                );
              }
            }

    />


  </div>

</div>    <div>
  <label  > Iron (Fe) </label>

  <div className="flex items-center gap-1" style={{textAlignLast:"center"}}>


    <input
      type="number"
      id="Quantity"
      min={0}

                defaultValue={
                  data.battery_composition.Fe
                }
                  onChange={(e) => {
                    setData(
                      {
                        ...data,
                        battery_composition: {
                          ...data.battery_composition,
                          Fe: e.target.value,
                        },
                      }
                    );
                  }
                }

    />


  </div>

</div>
          </div>
          <div className="grid grid-cols-1 gap-4 text-center sm:grid-cols-3">
          <div>
  <label > Cobalt (Co) </label>

  <div className="flex items-center gap-1" style={{textAlignLast:"center"}}>


    <input
      type="number"
      id="Quantity"
      min={0}

                  defaultValue={
                    data.battery_composition.Co
                  }
                    onChange={(e) => {
                      setData(
                        {
                          ...data,
                          battery_composition: {
                            ...data.battery_composition,
                            Co: e.target.value,
                          },
                        }
                      );
                    }
                  }


    />


  </div>

</div>
<div>
  <label  >Nickel (Ni) </label>

  <div className="flex items-center gap-1" style={{textAlignLast:"center"}}>


    <input
      type="number"
      id="Quantity"
      min={0}

                      defaultValue={
                        data.battery_composition.Ni
                      }
                        onChange={(e) => {
                          setData(
                            {
                              ...data,
                              battery_composition: {
                                ...data.battery_composition,
                                Ni: e.target.value,
                              },
                            }
                          );
                        }
                      }

    />


  </div>

</div>    <div>
  <label  > Titanium (Ti) </label>

  <div className="flex items-center gap-1" style={{textAlignLast:"center"}}>

    <input
      type="number"
      id="Quantity"
      min={0}

                          defaultValue={
                            data.battery_composition.Ti
                          }
                            onChange={(e) => {
                              setData(
                                {
                                  ...data,
                                  battery_composition: {
                                    ...data.battery_composition,
                                    Ti: e.target.value,
                                  },
                                }
                              );
                            }
                          }

    />


  </div>

</div>
          </div>


        </form>


		</section>
	);
};
